/**
 * KIND_CONFIG — canonical source of truth for run-kind display labels.
 *
 * Adding a new pipeline kind requires only an entry here.
 * Unknown kinds fall back to the raw kind string in the transform layer.
 * The `_unknown` entry provides the fallback label (empty string).
 */
export const KIND_CONFIG: Record<string, { label: string }> = {
  prd_refinement: { label: "PRD Refinement" },
  _unknown: { label: "" },
};
